import { registerLocaleData } from '@angular/common';
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFi from '@angular/common/locales/fi';
import localeFil from '@angular/common/locales/fil';
import localeFr from '@angular/common/locales/fr';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeMs from '@angular/common/locales/ms';
import localeNl from '@angular/common/locales/nl';
import localeNo from '@angular/common/locales/no';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSr from '@angular/common/locales/sr';
import localeSv from '@angular/common/locales/sv';
import localeTr from '@angular/common/locales/tr';
import localeZh from '@angular/common/locales/zh';
import { Injectable } from '@angular/core';
import flatpickr from 'flatpickr';
import * as flatpickrL10n from 'flatpickr/dist/l10n';
import { DC_LANGUAGES } from 'src/app/app.globals';

@Injectable({
    providedIn: 'root',
})
export class LocaleService {
    constructor() {}

    public registerLocales(): void {
        DC_LANGUAGES.forEach((language) => {
            registerLocaleData(this.getLocaleByKey(language.key), language.key);
        });
    }

    public setFlatpickrLocale(lang: string): void {
        let locale: flatpickr.CustomLocale;
        switch (lang) {
            case 'en':
                locale = flatpickrL10n.default.en;
                break;
            case 'nl':
                locale = flatpickrL10n.default.nl;
                break;
            case 'de':
                locale = flatpickrL10n.default.de;
                break;
            case 'bg':
                locale = flatpickrL10n.default.bg;
                break;
            case 'zh-CN':
                locale = flatpickrL10n.default.zh;
                break;
            case 'cs':
                locale = flatpickrL10n.default.cs;
                break;
            case 'da':
                locale = flatpickrL10n.default.da;
                break;
            case 'el':
                locale = flatpickrL10n.default.gr;
                break;
            case 'es':
                locale = flatpickrL10n.default.es;
                break;
            case 'fr':
                locale = flatpickrL10n.default.fr;
                break;
            case 'hr':
                locale = flatpickrL10n.default.hu;
                break;
            case 'it':
                locale = flatpickrL10n.default.it;
                break;
            case 'ja':
                locale = flatpickrL10n.default.ja;
                break;
            case 'ms':
                locale = flatpickrL10n.default.ms;
                break;
            case 'no':
                locale = flatpickrL10n.default.no;
                break;
            case 'hu':
                locale = flatpickrL10n.default.hu;
                break;
            case 'pl':
                locale = flatpickrL10n.default.pl;
                break;
            case 'pt':
                locale = flatpickrL10n.default.pt;
                break;
            case 'ro':
                locale = flatpickrL10n.default.ro;
                break;
            case 'ru':
                locale = flatpickrL10n.default.ru;
                break;
            case 'sr':
                locale = flatpickrL10n.default.sr;
                break;
            case 'fi':
                locale = flatpickrL10n.default.fi;
                break;
            case 'sv':
                locale = flatpickrL10n.default.sv;
                break;
            case 'tr':
                locale = flatpickrL10n.default.tr;
                break;
            default:
                locale = flatpickrL10n.default.en;
                break;
        }
        flatpickr.localize(locale);
    }

    private getLocaleByKey(key: string): (unknown | undefined)[] {
        switch (key) {
            case 'en':
                return localeEn;
            case 'nl':
                return localeNl;
            case 'de':
                return localeDe;
            case 'bg':
                return localeBg;
            case 'zh-CN':
                return localeZh;
            case 'cs':
                return localeCs;
            case 'da':
                return localeDa;
            case 'el':
                return localeEl;
            case 'es':
                return localeEs;
            case 'fr':
                return localeFr;
            case 'fil':
                return localeFil;
            case 'hr':
                return localeHr;
            case 'it':
                return localeIt;
            case 'ja':
                return localeJa;
            case 'ms':
                return localeMs;
            case 'no':
                return localeNo;
            case 'hu':
                return localeHu;
            case 'pl':
                return localePl;
            case 'pt':
                return localePt;
            case 'ro':
                return localeRo;
            case 'ru':
                return localeRu;
            case 'sr':
                return localeSr;
            case 'fi':
                return localeFi;
            case 'sv':
                return localeSv;
            case 'tr':
                return localeTr;
            default:
                return localeEn;
        }
    }
}
